import Vue from 'vue';
import Vuetify from 'vuetify/lib';

const theme = new Vuetify({
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    theme: {
        themes: {
            light: {
                primary: '#0AC1D3',
                secondary: '#253179',
                accent: '#5BC4FE',
                error: '#FC4161',
                info: '#0F70E6',
                warning: '#FFBE0B',
                success: '#275D2B',
            },
        },
    },
})

Vue.use(Vuetify, theme);

export default new Vuetify({
});
